export const actionTypes = {
    REFRESH_GATEWAY_SETTINGS: 'powertrainTools/gatewayManagement/REFRESH_GATEWAY_SETTINGS',
    REFRESH_GATEWAY: 'powertrainTools/gatewayManagement/REFRESH_GATEWAY',
    CLEAR_STORE: 'powertrainTools/gatewayManagement/refreshGateway/CLEAR_STORE'
};
